import logo from "@assets/images/logo_dg.png";
import { Link } from "react-router-dom";
import styles from "./SidebarLogo.module.css";

interface SidebarLogoProps {
  alt: string;
  url: string;
  imageSrc?: string;
}

export const SidebarLogo = ({ alt, url, imageSrc }: SidebarLogoProps) => {
  return (
    <Link to={url} className={styles.link} data-testid="sidebar-logo">
      <img src={imageSrc || logo} alt={alt} className={styles.image} />
    </Link>
  );
};
